import { ServicePageTemplate } from "./ServicePageTemplate";
import { getServiceBySlug } from "@/data/services";

const ThaiMassage = () => (
  <ServicePageTemplate service={getServiceBySlug("thai-massage")} />
);

export default ThaiMassage;
